import { cva, type VariantProps } from 'class-variance-authority';

export const buttonLayout = cva(
  ['mt-e lg:mt-c flex flex-col gap-b lg:gap-a md:flex-row flex-wrap'],
  {
    variants: {
      variant: {
        stackedCenter: 'md:items-start',
        centered: 'items-center justify-center',
        stackedLeft: 'items-start text-left',
      },
    },
    defaultVariants: {
      variant: 'stackedLeft',
    },
  }
);

export type ButtonLayout = VariantProps<typeof buttonLayout>;
